export default {
  // 打印
  print: 'controller.hardware.print',
  // 打印预览
  printPreview: 'controller.hardware.printPreview',
  // 打印结果
  printStatus: 'controller.hardware.printStatus',
  // 刷新打印模板
  reloadPrint: 'controller.hardware.reloadPrint',
  // 获取打印机列表
  getPrinterList: 'controller.hardware.getPrinterList',
  // 提示消息
  messageBox: 'service.message.messageBox',
  // 执行db操作
  dbExec: 'controller.framework.dbExec',
  // 下载文件
  downloadFile: 'controller.framework.downloadFile',
  // 保存错误日志
  errorLog: 'controller.framework.saveErrorLog',
  // 网络断开连接
  offline: 'controller.framework.offline',
  // 副屏操作
  updateViceScreen: 'controller.hardware.updateViceScreen',
  // 客显
  sendGuestShowData: 'controller.hardware.sendGuestShowData',
  // 获取客显串口列表
  getSerialPortList: 'controller.hardware.getSerialPortList',
  //最小化
  minimize: 'controller.os.minimize',
  //全屏
  fullScreen: 'controller.os.fullScreen',
  // 获取屏幕信息
  getScreen: 'controller.os.getScreen',
  //退出
  quit: 'controller.os.quit',
  // 获取应用信息
  getAppInfo: 'controller.updater.appInfo',
  // 重启应用
  relaunchApp: 'controller.updater.relaunchApp',
  // 检查更新
  checkForUpdater: 'controller.updater.checkForUpdater',
  // 下载app
  downloadApp: 'controller.updater.downloadApp',
  // 应用更新
  appUpdater: 'custom.app.updater',
  // 支付宝碰一碰插件安装(手动)
  zfbInstall: 'controller.os.installAbcp'
}
